module.exports = __webpack_public_path__ + "img/vampire2_smash.f216553a.gif";